import Utils from 'services/utils';

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * CategoriesApi class.
 */
export default class CategoriesApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.listUrl = Utils.buildApiUrl('categories.list');
    }

    /**
     * Get Categories
     * @returns {promise}
     */
    getList(params = {}) {
        return this.$http.get(this.listUrl, { params }).then(responseDataExtractor);
    }

    /**
     * Search Categories by query
     * @param {string} query - Search pattern
     * @param {Object} metadata - Request settings, like: limit, ofset etc.
     * @returns {promise}
     */
    search(query, metadata = {}) {
        return this.$http.get(
            this.listUrl,
            {
                params: {
                    query: `${query}*`,
                    ...metadata
                }
            })
            .then(responseDataExtractor);
    }

    /**
     * Create Category
     * @param {Object} category - Category object
     * @returns {*}
     */
    createCategory(category) {
        return this.$http.post(this.listUrl, category).then(responseDataExtractor);
    }

    /**
     * Get Category by given category id
     * @param {number} categoryId - Category id
     * @returns {promise}
     */
    getCategory(categoryId) {
        const url = Utils.buildApiUrl('categories.entity', { categoryId });

        return this.$http.get(url).then(responseDataExtractor);
    }

    saveCategory(categoryId, data) {
        const url = Utils.buildApiUrl('categories.entity', { categoryId });

        return this.$http.put(url, data).then(responseDataExtractor);
    }

    /**
     * Delete Category by given category id
     * @param {number} categoryId - Category id
     * @returns {promise}
     */
    deleteCategory(categoryId) {
        const url = Utils.buildApiUrl('categories.entity', { categoryId });

        return this.$http.delete(url).then(responseDataExtractor);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/categories/categories.service.js